import { render, staticRenderFns } from "./PlantationsSelector.vue?vue&type=template&id=23da8386&scoped=true"
import script from "./PlantationsSelector.vue?vue&type=script&lang=js"
export * from "./PlantationsSelector.vue?vue&type=script&lang=js"
import style0 from "./PlantationsSelector.vue?vue&type=style&index=0&id=23da8386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23da8386",
  null
  
)

export default component.exports